<template>
  <div>
    <router-link :to="{name: 'teacher'}" class="back-link">&larr; Back to all forms</router-link>
    <div class="form-name">{{formName}}</div>
    <div class="all-questions-container">
      <div
        class="question-container"
        v-for="(question, i) in questionsAndResponses"
        :key="`q-${i}-question.QuestionID`"
      >
        <ShortAnswerCompleted v-if="question.QuestionType === `short answer`" :question="question" />
        <LikertTypeCompleted v-if="question.QuestionType === `likert-type`" :question="question" />
      </div>
    </div>
  </div>
</template>

<script>
import ShortAnswerCompleted from "./ShortAnswerCompleted.vue";
import LikertTypeCompleted from "./LikertTypeCompleted.vue";
import store from "@/store/index.js";
import axios from "axios";
const apiBase = API_APP_PATH + "/v1";

export default {
  created() {
    const componentContext = this;
    componentContext
      .getQuestionsAndResponses()
      .then(res => {
        componentContext.formName = res[0].FormName;
        componentContext.questionsAndResponses = res;
      })
      .catch(e => {
        throw new Error(e);
      });
  },
  methods: {
    getQuestionsAndResponses: async function() {
      const responsesByFormAndUser = await axios.get(
        `${apiBase}/data/school/goalSetting/form/${this.$route.params.formid}/teacher/${store.state.employeeId}`
      );
      return responsesByFormAndUser.data;
    }
  },
  data() {
    return {
      questionsAndResponses: [],
      formName: ""
    };
  },
  components: {
    LikertTypeCompleted,
    ShortAnswerCompleted
  }
};
</script>

<style scoped>
.back-link {
  font-family: Arial, Helvetica, sans-serif;
}
.form-name {
  height: 2.25em;
  font-family: Arial;
  font-size: 1.5em;
  color: #000000;
  margin: 1em 0em 1em 0.5em;
}
</style>